export default "__VITE_ASSET__DX8huRpu__"